import { render } from "./Version.vue?vue&type=template&id=111735b8&scoped=true"
import script from "./Version.vue?vue&type=script&lang=js"
export * from "./Version.vue?vue&type=script&lang=js"

import "./Version.vue?vue&type=style&index=0&id=111735b8&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-111735b8"]])

export default __exports__